export const contasRoute: string = 'contas';
export const contasModuleName: any = {plural: 'Contas', single: 'Conta'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/shared/data.service.ts
 **/